import React, { Component } from "react";
import PropTypes from "prop-types";
import t from "@zendesk/client-i18n-tools";
import { Button } from "@zendeskgarden/react-buttons";
import { showEditRoute, showNewRoute } from "utils/navigation";
import styles from "./styles.css";
import { RULE_LIMIT } from "constants/limits";

import {
  Body,
  Cell,
  Head,
  HeaderCell,
  HeaderRow,
  Row,
  Table,
} from "@zendeskgarden/react-tables";

class RuleList extends Component {
  showNewRoute = () => showNewRoute();
  showEditRoute = ruleId => showEditRoute(ruleId);

  static propTypes = {
    verificationRules: PropTypes.object.isRequired,
  };

  render() {
    const { verificationRules } = this.props;

    const reachedLimit = verificationRules.total >= RULE_LIMIT;

    return (
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>
            {t("knowledge-verification.articleVerifications")}
          </h1>
          <Button
            data-test-id="add-verification-rule"
            onClick={this.showNewRoute}
            primary
            size="small"
            disabled={reachedLimit}
            title={
              reachedLimit
                ? t("knowledge-verification.ruleLimit", {
                    limit: RULE_LIMIT,
                  })
                : ""
            }
            aria-label={t("knowledge-verification.addVerificationRule")}
          >
            {t("knowledge-verification.add")}
          </Button>
        </div>
        <p>{t("knowledge-verification.listDescription")}</p>
        <div className={styles.table}>
          <Table size="large" data-test-id="rule-list">
            <Head>
              <HeaderRow>
                <HeaderCell width="50%">
                  {t("knowledge-verification.ruleListTable.name")}
                </HeaderCell>
                <HeaderCell width="30%">
                  {t("knowledge-verification.step.frequency")}
                </HeaderCell>
                <HeaderCell width="20%">
                  {t("knowledge-verification.ruleListTable.recipient")}
                </HeaderCell>
              </HeaderRow>
            </Head>
            <Body>
              {verificationRules.edges.map(({ node }) => (
                <Row
                  style={{ cursor: "pointer" }}
                  onClick={() => this.showEditRoute(node.id)}
                  key={node.id}
                >
                  <Cell width="50%" className={styles.cell}>
                    <span className={styles.ellipsis}>{node.name}</span>
                  </Cell>
                  <Cell width="30%" className={styles.cell}>
                    {t(`knowledge-verification.frequency.${node.frequency}`)}
                  </Cell>
                  <Cell width="20%" className={styles.cell}>
                    {t(
                      `knowledge-verification.notifications.recipient.${
                        node.notification.recipient
                      }`
                    )}
                  </Cell>
                </Row>
              ))}
            </Body>
          </Table>
        </div>
      </div>
    );
  }
}

export default RuleList;



// WEBPACK FOOTER //
// ./src/components/RuleList/index.js